export const MARKER_END2 = 'MARKER_END2'